import { NavLink } from "react-router-dom";
import { MOBILE_TOPICS } from "../registry/mobileTopics";

export function MobileTabBar() {
  return (
    <nav className="mobile-tab-bar" aria-label="Main navigation">
      {MOBILE_TOPICS.map((topic) => {
        const Icon = topic.icon;
        return (
          <NavLink
            key={topic.id}
            to={topic.path}
            end={topic.path === "/"}
            className={({ isActive }) =>
              ["mobile-tab-bar__tab", isActive ? "mobile-tab-bar__tab--active" : ""].join(" ")
            }
          >
            <Icon size={20} strokeWidth={1.75} aria-hidden />
            <span>{topic.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
